import React from 'react'
import PropTypes from 'prop-types'
import { midas } from '@resurs/midas'
import Select from '../../../../midasComponents/components/Select'
import TextInput from '../../../../midasComponents/components/TextInput'
import { getText } from '../../../../internal/TextLabels'
import { format } from '../../../../models/format'
import styles from './styles.module.scss'

const parseInput = input => (input && parseInt(`${input}`, 10)) || null

const OrderLine = ({ id, label, value, values, image, children, onChange }) => (
  <div className={styles.orderLineRow}>
    {image && (
      <div
        className={styles.orderLineImageCol}
        style={{ backgroundImage: `url(${image})` }}
      />
    )}
    <div className={styles.orderLineCol}>
      <div className={styles.orderLineColTop}>
        <label className={midas.formLabel}>
          <label className={midas.formLabel}>{label}</label>
        </label>
        {!!children && (
          <div className={styles.orderLineColDesc}>{children}</div>
        )}
      </div>
      {id && (
        <div className={styles.orderLineColBottom}>
          {values && values.length ? (
            <Select
              id={id}
              key={`${id}_${value}`}
              value={value || ''}
              values={[
                {
                  key: `${id}_none`,
                  value: null,
                  valueLabel: getText(
                    'support.pages.order.material.chooseAmount',
                  ),
                },
                ...values.map(val => ({
                  key: `${id}_${val}`,
                  value: `${val}`,
                  valueLabel: `${val}`,
                })),
              ]}
              onChange={newValue => onChange(id, parseInput(newValue))}
            />
          ) : (
            <TextInput
              id={id}
              placeholder={getText('support.pages.order.material.writeAmount')}
              value={value || ''}
              format={format.numbers}
              onChange={e => onChange(id, parseInput(e.target.value))}
            />
          )}
        </div>
      )}
    </div>
  </div>
)

OrderLine.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  values: PropTypes.array,
  image: PropTypes.string,
  children: PropTypes.any,
  onChange: PropTypes.func,
}

OrderLine.defaultProps = {
  id: null,
  value: '',
  values: [],
  image: null,
  children: null,
  onChange: () => {},
}

export default OrderLine
